/* eslint-disable react/require-default-props */
import React, { useLayoutEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import clsx from 'classnames';
import { Toolbar } from '../../Toolbar/Toolbar';
import { useAnchoredSelectionToolbar } from '../../Toolbar/useAnchoredSelectionToolbar';
import { toolbarGroupItems } from '../tableUtils';
/**
 * TableMassToolbar
 *
 * Renders the mass-action Toolbar (Toolbar.Selection + consumer groups +
 * optional Configure). When `anchorElement` is supplied the bar renders in a
 * portal, fixed to the first selected row, and sticks under the page header
 * once that row scrolls past (decisions 20–22).
 *
 * Remounts when selection crosses zero so Toolbar's overflow re-measures.
 */
export function TableMassToolbar({ toolbar, selectionCount, selectionTotal, selectAll, onSelectAll, selectAllLabel, showSelection, selectionState, configureCluster, hasFilterBar, anchorElement, contentWidth = '100%', selectedLabel, selectPageLabel, onSelectPage, selectMatchingLabel, onSelectMatching, clearLabel, onClear }) {
    const isFloating = anchorElement !== undefined;
    const [pageHeader, setPageHeader] = useState(null);
    useLayoutEffect(() => {
        setPageHeader(document.querySelector('#global-header, .global-header, nav.navbar, .qmb-ui-header--sticky, .qmb-ui-header'));
    }, []);
    const { stuck, style } = useAnchoredSelectionToolbar(isFloating ? anchorElement !== null && anchorElement !== void 0 ? anchorElement : null : null, pageHeader, contentWidth);
    if (showSelection && selectionCount === 0) {
        return null;
    }
    const toolbarEl = (React.createElement(Toolbar, { key: selectionCount > 0 ? 'table-toolbar-selected' : 'table-toolbar-idle', className: toolbar.className, moreActionsLabel: toolbar.moreActionsLabel },
        showSelection && (React.createElement(Toolbar.Selection, { count: selectionCount, totalCount: selectionTotal, selectAll: selectAll, onSelectAll: onSelectAll, selectAllLabel: selectAllLabel, selectedLabel: selectedLabel, selectPageLabel: selectPageLabel, onSelectPage: onSelectPage, selectMatchingLabel: selectMatchingLabel, onSelectMatching: onSelectMatching, clearLabel: clearLabel, onClear: onClear })),
        toolbar.groups.map((group) => (React.createElement(Toolbar.Group, { key: group.id, pinned: group.pinned, align: group.align, className: group.className }, toolbarGroupItems(group.content, selectionState)))),
        !hasFilterBar && configureCluster && (React.createElement(Toolbar.Group, { key: "table-column-visibility", pinned: true, align: "end" }, configureCluster))));
    if (!isFloating || !anchorElement) {
        return toolbarEl;
    }
    const floatingBar = (React.createElement("div", { 
        /* eslint-disable @typescript-eslint/naming-convention */
        className: clsx('qmb-ui-table__floating-toolbar', {
            'qmb-ui-table__floating-toolbar--anchored': !stuck,
            'qmb-ui-table__floating-toolbar--stuck': stuck
        }), 
        /* eslint-enable @typescript-eslint/naming-convention */
        style: style }, toolbarEl));
    return ReactDOM.createPortal(floatingBar, document.body);
}
